module.exports = __webpack_public_path__ + "static/img/14010104.90410fce.png";